<template>
    <el-drawer :title="type == 1 ? '评论' : '回复'" :visible.sync="drawerShow" :wrapperClosable="false"
        :destroy-on-close="true" size="auto" @close="close">
        <div class="drawer-content">
            <el-form :model="formDatas" :rules="rules" ref="formDatas" label-position="top" size="medium">
                <el-form-item prop="user" :label="type == 1 ? '评论人:' : '回复人:'">
                    <el-select v-model="formDatas.user" filterable remote placeholder="请输入用户名"
                        :remote-method="searchUser" :loading="userLoading" size="medium" value-key="id">
                        <el-option v-for="item in userList" :key="item.id" :label="item.name" :value="item">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="content" label="内容">
                    <el-input v-model="formDatas.content" placeholder="请输入内容" show-word-limit maxlength="500" type="textarea" :rows="4"></el-input>
                </el-form-item>
            </el-form>
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading">确认</el-button>
        </div>
    </el-drawer>
</template>
<script>
import { fetchUser } from "@/assets/js/commonApi.js";
const defaultData = {
    "articleId": "",
    "content": "",
    "isDeclare": 0,
    "reviewId": "",
    "userId": "",
    "userName": ""
}
export default {
    data() {
        return {
            drawerShow: false,
            btnLoading: false,
            formDatas: {
                ...defaultData,
                user: null
            },
            rules: {
                user: [{ required: true, message: "请选择用户" }],
                content: [{ required: true, message: "请输入内容" }],
            },
            userList: [],
            userLoading: false,

            type: 1, //1:帖子-评论，2:评论-回复
        }
    },
    methods: {
        close() {
            this.$refs.formDatas.resetFields();
            this.drawerShow = false;
            this.formDatas = {
                ...defaultData
            }
        },
        show(articleId, type, reviewId) {
            this.type = type;
            this.formDatas.articleId = articleId;
            if( reviewId ){
                this.formDatas.reviewId = reviewId;
            }
            this.drawerShow = true;
        },
        // 搜索用户
        async searchUser(query) {
            if (query !== "") {
                this.userLoading = true;
                const res = await fetchUser({
                    queryValue: query,
                    userType: 0
                }).finally(() => {
                    this.userLoading = false;
                });

                const { state, result } = res.data;

                if (state == 1 && result) {
                    this.userList = result;
                }
            }
        },
        submitForm() {
            this.$refs["formDatas"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    this.$request({
                        url: '/article/review/new',
                        data: {
                            ...this.formDatas,
                            userId: this.formDatas.user.id,
                            userName: this.formDatas.user.name
                        },
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.close();
                                setTimeout( () => {
                                    this.$emit('onUpdate');
                                },1500)
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            this.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                } else {
                    return false;
                }
            });
        }
    }
}
</script>

<style lang="scss" scoped>
</style>